<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { api, setAccessToken } from "$lib/api/client";
  import { navigate } from "$lib/router.svelte";

  let loading = $state(true);
  let error = $state<string | null>(null);

  $effect(() => {
    loginAsDemo();
  });

  async function loginAsDemo() {
    try {
      const r = await api<{ access_token: string; user: any }>("/demo/login", { method: "POST" });
      setAccessToken(r.access_token);
      // Marcar como demo na sessão
      sessionStorage.setItem("takite.demo", "1");
      localStorage.setItem("takite.onboarded", "1"); // pular onboarding no demo
      // Bootstrap do auth
      await auth.bootstrap();
      navigate("/dashboard");
    } catch (e: any) {
      error = e?.body?.detail || e?.message || "Erro ao entrar no modo demo";
      loading = false;
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center px-4">
  {#if error}
    <div class="card text-center space-y-4 max-w-sm">
      <div class="text-4xl">😕</div>
      <p class="text-muted text-sm">{error}</p>
      <button class="btn-primary" onclick={() => navigate("/")}>Voltar</button>
    </div>
  {:else}
    <div class="text-center space-y-3">
      <div class="text-4xl animate-pulse">🎮</div>
      <p class="text-muted text-sm">Carregando modo demo…</p>
    </div>
  {/if}
</div>
